import type { StyleOption } from "./style-types";

export const MARKETING_STYLES: StyleOption[] = [
  marketingStyle("business-blue", "商务蓝", "稳健、清晰、企业感", "business", ["#F7F9FC", "#163A70", "#2F67E8", "#132238"]),
  marketingStyle("executive-navy", "高管深蓝", "深色克制，突出关键决策", "business", ["#0B1730", "#EAF0FA", "#D6A94F", "#F5F7FB"]),
  marketingStyle("minimal-light", "极简亮色", "充分留白，聚焦核心表达", "minimal", ["#FAFAF8", "#20252D", "#E05245", "#20252D"]),
  marketingStyle("data-editorial", "数据研报", "多栏图表，信息密集但有条理", "education", ["#F4F1E9", "#202020", "#C83E36", "#202020"]),
  marketingStyle("tech-dark", "深色科技", "深色画布，发光强调与数据面板", "tech", ["#071425", "#E8F2FF", "#36D2C1", "#F2F7FF"]),
  marketingStyle("warm-story", "暖调叙事", "柔和自然，适合产品故事与培训", "creative", ["#FBF7F0", "#4A3B32", "#E07A5F", "#3E342E"]),
];

export function marketingStyleForCode(code: string): StyleOption | undefined {
  return MARKETING_STYLES.find((style) => style.code === code);
}

function marketingStyle(
  code: string,
  name: string,
  tagline: string,
  category: string,
  palette: [string, string, string, string],
): StyleOption {
  return {
    code,
    version: "1.0.0",
    name,
    tagline,
    description: tagline,
    category,
    releaseStage: "public",
    recommendedWeight: 1,
    sceneCodes: [],
    tags: [],
    previewTheme: code,
    rendererCompatibility: { dfai: true, image2: true, html_ppt: false },
    palette,
  };
}
